enum NoContentTypes {
  BOOKMARK_BUSINESS_EMPTY,
  DEFAULT,
  EMPTY_PUBLIC_PLACES,
  ERROR,
  LOCATION_SEARCH_EMPTY,
  LOCATION_SEARCH_GUIDE,
  NO_FOLDER_AUTHORITY,
  NO_PLACES_IN_SCOPE,
  PLACE,
  PLACE_FOLDERS_API_RESPONSE_ERROR,
  PLACE_NOT_LOGGED_IN,
  PUBLIC_FOLDER_EMPTY,
  REMOVED_FOLDER,
  PRIVATE_FOLDER,
  REVIEW,
  REVIEW_GUEST,
  REVIEW_GUEST_NO_PHOTO,
  REVIEW_NO_DELIVERY,
  REVIEW_NO_PHOTO,
  REVIEW_NO_RECEIPT,
  REVIEW_NO_RESERVATION,
  REVIEW_NO_RESULT,
  REVIEW_NOT_AVAILABLE,
  REVIEW_NOT_FOUND,
  THEME_NO_PHOTO_REVIEW,
  THEME_NO_REVIEW,
  THEME_NO_REVIEW_SORT,
  THEME_REMOVED,
  UNAUTHORIZED_PLACE,
  VISIT,
  VISIT_NOT_AVAILABLE,
  VISIT_NOT_LOGGED_IN,
  FOLLOWERS,
  FOLLOWING,
  FEED,
  FEED_LOGIN,
  FEED_FOLLOWER,
  FEED_FOLLOWING,
  FEED_FOLLOWING_REVIEW,
  BLOCK,
  BOOKMARK_LIST_EMPTY,
  BOOKMARK_AROUND_EMPTY,
  TEMPORARY_SUSPENSION_NOTICE,
  PERMANENT_SUSPENSION_NOTICE,
  NO_LIST_FOR_CHECK_IN,
  NO_PAYMENTS_FOR_CHECK_IN,
  NO_REVIEW_IN_REVIEW_TAB,
  NO_REVIEW_IN_REVIEW_TAB_TYPE_MINE,
  CLIP_NOT_FOUND,
}

enum TabPanelNoContentTypes {
  VISIT = 'visit',
  REVIEW = 'review',
  REVIEW_OTHER = 'review_other',
  BOOKMARK = 'bookmark',
  ERROR = 'error',
}

export { TabPanelNoContentTypes, NoContentTypes }
